export const stateList = [
  {
    name: 'Alabama',
    abbreviation: 'AL',
    numberCode: '01',
  },
  {
    name: 'Alaska',
    abbreviation: 'AK',
    numberCode: '02',
  },
  {
    name: 'American Samoa',
    abbreviation: 'AS',
  },
  {
    name: 'Arizona',
    abbreviation: 'AZ',
    numberCode: '04',
  },
  {
    name: 'Arkansas',
    abbreviation: 'AR',
    numberCode: '05',
  },
  {
    name: 'California',
    abbreviation: 'CA',
    numberCode: '06',
  },
  {
    name: 'Colorado',
    abbreviation: 'CO',
    numberCode: '08',
  },
  {
    name: 'Connecticut',
    abbreviation: 'CT',
    numberCode: '09',
  },
  {
    name: 'Delaware',
    abbreviation: 'DE',
    numberCode: '10',
  },
  {
    name: 'District of Columbia',
    abbreviation: 'DC',
    numberCode: '11',
  },
  {
    name: 'Federated States Of Micronesia',
    abbreviation: 'FM',
  },
  {
    name: 'Florida',
    abbreviation: 'FL',
    numberCode: '12',
  },
  {
    name: 'Georgia',
    abbreviation: 'GA',
    numberCode: '13',
  },
  {
    name: 'Guam',
    abbreviation: 'GU',
  },
  {
    name: 'Hawaii',
    abbreviation: 'HI',
    numberCode: '15',
  },
  {
    name: 'Idaho',
    abbreviation: 'ID',
    numberCode: '16',
  },
  {
    name: 'Illinois',
    abbreviation: 'IL',
    numberCode: '17',
  },
  {
    name: 'Indiana',
    abbreviation: 'IN',
    numberCode: '18',
  },
  {
    name: 'Iowa',
    abbreviation: 'IA',
    numberCode: '19',
  },
  {
    name: 'Kansas',
    abbreviation: 'KS',
    numberCode: '20',
  },
  {
    name: 'Kentucky',
    abbreviation: 'KY',
    numberCode: '21',
  },
  {
    name: 'Louisiana',
    abbreviation: 'LA',
    numberCode: '22',
  },
  {
    name: 'Maine',
    abbreviation: 'ME',
    numberCode: '23',
  },
  {
    name: 'Marshall Islands',
    abbreviation: 'MH',
  },
  {
    name: 'Maryland',
    abbreviation: 'MD',
    numberCode: '24',
  },
  {
    name: 'Massachusetts',
    abbreviation: 'MA',
    numberCode: '25',
  },
  {
    name: 'Michigan',
    abbreviation: 'MI',
    numberCode: '26',
  },
  {
    name: 'Minnesota',
    abbreviation: 'MN',
    numberCode: '27',
  },
  {
    name: 'Mississippi',
    abbreviation: 'MS',
    numberCode: '28',
  },
  {
    name: 'Missouri',
    abbreviation: 'MO',
    numberCode: '29',
  },
  {
    name: 'Montana',
    abbreviation: 'MT',
    numberCode: '30',
  },
  {
    name: 'Nebraska',
    abbreviation: 'NE',
    numberCode: '31',
  },
  {
    name: 'Nevada',
    abbreviation: 'NV',
    numberCode: '32',
  },
  {
    name: 'New Hampshire',
    abbreviation: 'NH',
    numberCode: '33',
  },
  {
    name: 'New Jersey',
    abbreviation: 'NJ',
    numberCode: '34',
  },
  {
    name: 'New Mexico',
    abbreviation: 'NM',
    numberCode: '35',
  },
  {
    name: 'New York',
    abbreviation: 'NY',
    numberCode: '36',
  },
  {
    name: 'North Carolina',
    abbreviation: 'NC',
    numberCode: '37',
  },
  {
    name: 'North Dakota',
    abbreviation: 'ND',
    numberCode: '38',
  },
  {
    name: 'Northern Mariana Islands',
    abbreviation: 'MP',
  },
  {
    name: 'Ohio',
    abbreviation: 'OH',
    numberCode: '39',
  },
  {
    name: 'Oklahoma',
    abbreviation: 'OK',
    numberCode: '40',
  },
  {
    name: 'Oregon',
    abbreviation: 'OR',
    numberCode: '41',
  },
  {
    name: 'Palau',
    abbreviation: 'PW',
  },
  {
    name: 'Pennsylvania',
    abbreviation: 'PA',
    numberCode: '42',
  },
  {
    name: 'Puerto Rico',
    abbreviation: 'PR',
  },
  {
    name: 'Rhode Island',
    abbreviation: 'RI',
    numberCode: '44',
  },
  {
    name: 'South Carolina',
    abbreviation: 'SC',
    numberCode: '45',
  },
  {
    name: 'South Dakota',
    abbreviation: 'SD',
    numberCode: '46',
  },
  {
    name: 'Tennessee',
    abbreviation: 'TN',
    numberCode: '47',
  },
  {
    name: 'Texas',
    abbreviation: 'TX',
    numberCode: '48',
  },
  {
    name: 'Utah',
    abbreviation: 'UT',
    numberCode: '49',
  },
  {
    name: 'Vermont',
    abbreviation: 'VT',
    numberCode: '50',
  },
  {
    name: 'Virgin Islands',
    abbreviation: 'VI',
  },
  {
    name: 'Virginia',
    abbreviation: 'VA',
    numberCode: '51',
  },
  {
    name: 'Washington',
    abbreviation: 'WA',
    numberCode: '53',
  },
  {
    name: 'West Virginia',
    abbreviation: 'WV',
    numberCode: '54',
  },
  {
    name: 'Wisconsin',
    abbreviation: 'WI',
    numberCode: '55',
  },
  {
    name: 'Wyoming',
    abbreviation: 'WY',
    numberCode: '56',
  },
];

export const countryList = [
  'United States (USA)',
  'Afghanistan',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas (the)',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia (Plurinational State of)',
  'Bonaire, Sint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory (the)',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cabo Verde',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cayman Islands (the)',
  'Central African Republic (the)',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands (the)',
  'Colombia',
  'Comoros (the)',
  'Congo (the Democratic Republic of the)',
  'Congo (the)',
  'Cook Islands (the)',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Curaçao',
  'Cyprus',
  'Czechia',
  "Côte d'Ivoire",
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic (the)',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Eswatini',
  'Ethiopia',
  'Falkland Islands (the) [Malvinas]',
  'Faroe Islands (the)',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories (the)',
  'Gabon',
  'Gambia (the)',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (the)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran (Islamic Republic of)',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  "Korea (the Democratic People's Republic of)",
  'Korea (the Republic of)',
  'Kuwait',
  'Kyrgyzstan',
  "Lao People's Democratic Republic (the)",
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands (the)',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia (Federated States of)',
  'Moldova (the Republic of)',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands (the)',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger (the)',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands (the)',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine, State of',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines (the)',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Republic of North Macedonia',
  'Romania',
  'Russian Federation (the)',
  'Rwanda',
  'Réunion',
  'Saint Barthélemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan (the)',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan (Province of China)',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands (the)',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates (the)',
  'United Kingdom of Great Britain and Northern Ireland (the)',
  'United States Minor Outlying Islands (the)',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela (Bolivarian Republic of)',
  'Viet Nam',
  'Virgin Islands (British)',
  'Virgin Islands (U.S.)',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
  'Åland Islands',
];
